var fa = {};
module['exports'] = fa;
fa.title = "Farsi";
fa.name = require("./name");
fa.address = require("./address");
